import { render } from "./AutoCompleteInputText.vue?vue&type=template&id=7f8bcc52"
import script from "./AutoCompleteInputText.vue?vue&type=script&lang=js"
export * from "./AutoCompleteInputText.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\GhanaWaterHelpCenter\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__